import React, { useState, useEffect, useMemo } from "react";
import { Link, NavLink } from "react-router-dom";
import $ from "jquery";
import * as R from "ramda";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import PrinterDoc from "./../../_common/printerDoc";
import { UploadArea } from "./../../_common/upload-area";

import { AlertProfile } from "./../_common/alertProfile";
import { ProcessDeces } from "./../_common/processDeces";
import { DonnesProfile } from "./../_common/donnesProfile";
import { CloseProfile } from "./../_common/closeProfile";
import { HistoriqueProfile } from "./../_common/historiqueProfile";
import { EditProfile } from "./../_common/EditProfile";
import { PrintModal } from "./../_common/printModal";
import { DossiersCard } from "./card";

import { fetchUserById, fetchUserInvoicesById, getDeathDeclaration, getDocuments, GetEtablissementById, getLettersForUserId, GetPartnerById, getUserServiceData, getUserServices, resetDetailUser } from "../../../actions/backoffice/user";
import * as Loadings from "../../../constants/loadings/user";
import * as LoadingsFacilita from "../../../constants/loadings/facilita/deathDeclaration";
import * as urls from "../../../constants/webapi/facilita";

import Emptylustration from "./../../../assets/images/svg/057-contract-1.svg";
import previewPdf from "./../../../assets/images/placeholder/pdf-placeholder.jpg";

import notaire from "./../../../assets/images/svg/004-A-notaire.png";
import securitesociale from "./../../../assets/images/svg/004-A-securitesocial.png";
import banque from "./../../../assets/images/svg/004-A-banque.svg";
import mutuelle from "./../../../assets/images/svg/004-A-mutuelle.svg";
import assurance from "./../../../assets/images/svg/100-assurance.svg";
import fournisseureau from "./../../../assets/images/svg/004-A-fournisseureau.svg";
import fournisseurelectricite from "./../../../assets/images/svg/004-A-fournisseurelectricite.svg";
import telephonemobile from "./../../../assets/images/svg/004-A-telephonemobile.svg";
import centreimpots from "./../../../assets/images/svg/004-A-dgfip.png";

import sport from "./../../../assets/images/svg/004-B-sport.svg";
import internet from "./../../../assets/images/svg/004-B-internet.svg";
import loisirs from "./../../../assets/images/svg/004-B-loisirs.svg";
import voitures from "./../../../assets/images/svg/004-B-voiture.svg";
import transport from "./../../../assets/images/svg/004-B-transport.svg";
import entretienmaison from "./../../../assets/images/svg/004-B-entretienmaison.svg";
import securite from "./../../../assets/images/svg/004-B-securite.svg";
import soinesthetique from "./../../../assets/images/svg/004-B-soinesthetique.svg";
import domicile from "./../../../assets/images/svg/004-B-domicile.svg";
import musique from "./../../../assets/images/svg/004-B-musique.svg";
import cartepaiment from "./../../../assets/images/svg/004-B-cartepaiment.svg";
import multimedia from "./../../../assets/images/svg/004-B-multimedia.svg";
import tech from "./../../../assets/images/svg/004-B-tech.svg";
import tv from "./../../../assets/images/svg/004-B-tv.svg";
import solidaire from "./../../../assets/images/svg/004-B-solidaire.svg";
import autres from "./../../../assets/images/svg/004-B-autres.svg";

import reseauxsociaux from "./../../../assets/images/svg/104-social-media.svg";
import loisir from "./../../../assets/images/svg/029-football-ball.svg";
import pet from "./../../../assets/images/svg/028-pet-food.svg";
import mobile from "./../../../assets/images/svg/024-furniture.svg";
import personnes from "./../../../assets/images/svg/024-account.svg";
import duo from "./../../../assets/images/svg/088-duo.svg";
import { LoadingState } from "../../../_common/loadingState";
//import { getDocuments, getLettersForUserId, getUserConnections, getUserRepresentativesForUserId, getUserServiceData } from '../../../actions/facilita-api';
import { AuxiliarOptions, CommonServices, ConnectionTypes, convertConnectionTypesToServiceType, isInsurance, isSocialNetwork, OtherService, PersonalServices } from "../../../constants/utils/connectionTypes";
import { getUserAddress, getUserMessage, getUserRepresentatives, getUserConnections } from "../../../actions/backoffice/user";
import { fetchAllServiceData } from "../../../actions/services-api";
import { FrenchTypes } from "../../../constants/utils/connectionTypes";
import { PreviewDoc } from "../_common/previewDoc";
import { PreviewDocLetter } from "../_common/previewDocLetter";
import { resetPassword } from "../../../actions/auth-api";
import { PaySummary } from "../_common/paySummary";

export const DossiersDetail = () => {
	const dispatch = useDispatch();
	const params = useParams();
	const userId = params.user;
	const userState = useSelector((state) => state.userBackOfficeDetailReducer);

	const [serviceDataLetters, setServiceDataLetters] = useState([]);
	const [userDocuments, setUserDocuments] = useState({ items: [doc("démarches", "communes", 0, 0), doc("démarches", "personnalisées", 0, 0)] });
	const [selectedServices, setSelectedServices] = useState(undefined);
	const [selectedUserLetter, setSelectedUserLetter] = useState(undefined);
	const [selectedUserService, setSelectedUserService] = useState({});
	const [documentUrl, setDocumentUrl] = useState(undefined);
	const [serviceLetter, setServiceLetter] = useState([]);
	const [validatedletterSections, setValidatedletterSections] = useState([]);
	const [lettersChoice, setLettersChoice] = useState({});
	const currentDate = new Date();

	// const statusOptions = { notAccepted: "N'a pas accepté", ongoing: "En cours", finished: "Complété", yearAndMore: "Contrat d'un an", sending: 'A envoyer', overtime: "Dépassé la limite", closed: "Clôture" };
	const statusOptions = { notAccepted: "N'a pas accepté", ongoing: "En cours", finished: "Complété", yearAndMore: "Contrat d'un an", sending: "A envoyer", closed: "Clôture" };
	let noneLetter = ["Rempli", "Non rempli", "Lettres générées"];
	let greenStatus = ["Lettres validées", "Lettres imprimées", "Lettres postées", "Lettres distribuées", "Traité"];
	let blueStatus = ["Rempli", "Lettres générées", "En traitement..."];

	const mainRepresentative = useMemo(() => userState.referents.find((u) => u.isMainRepresentative), [userState.referents]);
	const representatives = useMemo(() => userState.referents.filter((u) => !u.isMainRepresentative), [userState.referents]);

	function doc(firstTitle, secondTitle, num, actions) {
		return { firstTitle: firstTitle, secondTitle: secondTitle, num: num, actions: actions };
	}

	useEffect(() => {
		$('[data-toggle="tooltip"]').tooltip();

		dispatch(fetchUserById(userId));

		return () => dispatch(resetDetailUser());

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (!R.isNil(userState.user)) {
			dispatch(getUserServices(userState.user));
			dispatch(getUserAddress(userState.user.id));
			dispatch(getUserRepresentatives(userState.user.id));
			dispatch(getUserServiceData(userState.user.id, undefined));
			dispatch(getLettersForUserId(userState.user.id));
			dispatch(getDocuments({ id: userState.user.id }));
			dispatch(fetchUserInvoicesById(userState.user.id));

			if (userState.user.isDeceased) {
				dispatch(getDeathDeclaration(userState.user.id, undefined));
			}
			//dispatch(getUserConnections(userState.user.id));
		}
		// eslint-disable-next-line
	}, [userState.user]);

	useEffect(() => {
		let userCommunServices = Object.values(CommonServices)
			.filter((u) => userState.services.some((i) => i.connectionType === u.connectionType))
			.map((srv) => {
				let progress = userState.serviceDatas.some((s) => s.serviceType === convertConnectionTypesToServiceType(srv.connectionType)) ? 100 : 0;
				return progress === 100 ? 0 : 1;
			});

		let userPersonnalServices = Object.values(PersonalServices)
			.concat(Object.values(AuxiliarOptions))
			.concat(Object.values(OtherService))
			.filter((u) => userState.services.some((i) => (isSocialNetwork(i.connectionType) ? ConnectionTypes.socialNetworks === u.connectionType : isInsurance(i.connectionType) ? ConnectionTypes.insurance === u.connectionType : i.connectionType === u.connectionType)))
			.map((srv) => {
				let progress = userState.serviceDatas.some((s) => s.serviceType === convertConnectionTypesToServiceType(srv.connectionType)) ? 100 : 0;
				return progress === 100 ? 0 : 1;
			});

		let demarchesCommuneDocuments = userDocuments.items.find((d) => d.secondTitle === "communes");
		demarchesCommuneDocuments.num = userCommunServices.length;
		demarchesCommuneDocuments.actions = userCommunServices.reduce((a, b) => a + b, 0);
		demarchesCommuneDocuments.done = demarchesCommuneDocuments.num - demarchesCommuneDocuments.actions;
		demarchesCommuneDocuments.percent = (demarchesCommuneDocuments.done * 100) / demarchesCommuneDocuments.num;

		let demarchesPersonnaliseeDocuments = userDocuments.items.find((d) => d.secondTitle === "personnalisées");
		demarchesPersonnaliseeDocuments.num = userPersonnalServices.length;
		demarchesPersonnaliseeDocuments.actions = userPersonnalServices.reduce((a, b) => a + b, 0);
		demarchesPersonnaliseeDocuments.done = demarchesPersonnaliseeDocuments.num - demarchesPersonnaliseeDocuments.actions;
		demarchesPersonnaliseeDocuments.percent = (demarchesPersonnaliseeDocuments.done * 100) / demarchesPersonnaliseeDocuments.num;

		setUserDocuments({ ...userDocuments, items: [demarchesCommuneDocuments, demarchesPersonnaliseeDocuments] });

		let _validatedletterSections = [
			...Object.values(CommonServices).filter((u) => userState.services.some((i) => i.connectionType === u.connectionType)),
			...Object.values(PersonalServices)
				.concat(Object.values(AuxiliarOptions))
				.filter((u) => userState.services.some((i) => (isSocialNetwork(i.connectionType) ? ConnectionTypes.socialNetworks === u.connectionType : isInsurance(i.connectionType) ? ConnectionTypes.insurance === u.connectionType : i.connectionType === u.connectionType))),
			...Object.values(OtherService).filter((u) => userState.services.some((i) => i.connectionType === u.connectionType)),
		].filter((srv) => {
			const chosenServiceData = userState.serviceDatas.filter((s) => s.serviceType === convertConnectionTypesToServiceType(srv.connectionType));
			const userLettersFiltered = userState.userLetters.filter((ul) => chosenServiceData.some((sd) => sd.id === ul.userServiceId));
			return userLettersFiltered.some((letter) => letter.letterProgressStage === "Validated");
		});
		setValidatedletterSections(_validatedletterSections);
	}, [userState]);

	useEffect(() => {
		if (!R.isNil(selectedUserLetter)) {
			setDocumentUrl({
				url: urls.letterContentUrlByletterId(selectedUserLetter.id),
				httpHeaders: {
					Authorization: "Bearer " + sessionStorage.getItem("access_token"),
				},
			});
		}
	}, [selectedUserLetter]);

	function handleGetPartnerAndEtablissement() {
		if (!R.isNil(userState.user.partnerId)) {
			dispatch(GetPartnerById(userState.user.partnerId));
		}
		if (!R.isNil(userState.user.etablissementId)) {
			dispatch(GetEtablissementById(userState.user.partnerId, userState.user.etablissementId));
		}
	}

	if (userState.isLoading.includes(Loadings.FETCH_USER)) {
		return <LoadingState />;
	}
	if (R.isNil(userState.user)) {
		return "";
	}

	return (
		<React.Fragment>
			<nav className="nav py-3 pt-gd-3 pt-lg-4">
				<div className="container-fluid mt-1 mb-2">
					<div className="flex-column flex-md-row align-items-center justify-content-md-between">
						<Link to="/backoffice/dossiers" className="h6 font-weight-regular my-md-auto text-gray">
							<i className="eva eva-corner-up-left-outline fs-sm align-middle mr-2"></i>
							<span className="align-middle">
								Voir tout les <span className="d-md-none d-lg-inline-block">Dossiers</span>
							</span>
						</Link>

						<div className="flex-row">
							{userState.user.createdByRepresentative && !userState.user.hasDocumentSending && userState.user.isSerenita ? (
								<button type="button" className="btn btn-faded px-3 px-xl-4 mr-md-2" data-toggle="modal" data-target="#printModal">
									Impressions
								</button>
							) : (
								""
							)}

							{/* <button type="button" className="btn btn-secondary px-3 px-xl-4 ml-md-auto mr-md-2">Ajouter referente</button> */}
							{userState.user.isEnabled ? (
								<button type="button" className="btn btn-faded px-3 px-xl-4 mr-md-0" data-toggle="modal" data-target="#closeProfile">
									Clôture du dossier
								</button>
							) : (
								""
							)}
							{/* <button type="button" className="btn btn-faded px-3 px-xl-4 mr-md-0 disabled" data-toggle="modal">Clôture du dossier</button> */}
						</div>
					</div>
				</div>
				<ProcessDeces userId={userState.user.id} birthDate={userState.user.birthDate} address={userState.address} />
			</nav>
			<article className="view-calc h-auto pb-3 mb-auto">
				<div className="container-fluid">
					<header className="alert bg-common rounded-bottom-left-sm rounded-top-right-sm mb-sm px-3 sticky-gd-top">
						<div className="row gx-2 mb-2 align-items-center">
							<div className="col">
								<h2 className="h2 font-weight-demi ls-n1 text-primary mb-sm my-auto">
									{userState.user.firstName} {userState.user.lastName}
								</h2>

								{/* <div className="row align-items-center gx-1 mt-1">
									<p className="h6 font-weight-demi my-auto">
										<span className="o-60 align-middle">Date d'inscription: </span>
										<span className="align-middle">{new Intl.DateTimeFormat('fr-FR').format(userState.user.setupCompletedDate)}</span>
									</p>
									<span className="o-20 align-middle fs-xs">|</span> */}
								<div className="row align-items-center gx-1">
									<p className="h6 font-weight-demi my-auto">
										<span className="o-60 align-middle">Date de naissance: </span>
										<span className="align-middle">{new Intl.DateTimeFormat("fr-FR").format(userState.user.birthDate)}</span>
									</p>
									<br />
									{userState.deathDate && (
										<React.Fragment>
											{/* <span className="px-0"><i className='eva eva-minus-outline o-50 align-middle'></i></span> */}
											<p className="h6 font-weight-demi my-auto">
												<span className="o-60">Date de décès: </span>
												<span>{new Intl.DateTimeFormat("fr-FR").format(userState.deathDate)}</span>
											</p>
										</React.Fragment>
									)}
								</div>
								{/* </div> */}
								{/* <p className="h6 font-weight-demi mb-auto mt-1"><span className="o-60">Date de naissance: </span>{new Intl.DateTimeFormat('fr-FR').format(userState.user.birthDate)}</p> */}
							</div>
							<div className="col">
								<div className="h6 font-weight-bolder mt-auto mb-1 o-60">Création de dossier</div>
								<p className="h6 font-weight-demi mb-auto">{new Intl.DateTimeFormat("fr-FR").format(userState.user.creationDate)}</p>
							</div>
							<div className="col">
								<div className="h6 font-weight-bolder mt-auto mb-1 o-60">Date activation</div>
								<p className="h6 font-weight-demi mb-auto">{new Intl.DateTimeFormat("fr-FR").format(userState.user.onBoardingCompletedDate)}</p>
							</div>
							<div className="col">
								<div className="h6 font-weight-bolder mt-auto mb-1 o-60">{userState.user.isDeceased ? "Date de paiement du dossier" : "Prochaine date de paiement du dossier"}</div>
								{userState.user.billedByPartner ? (
									userState.user.isDeceased ? (
										<p className="h6 font-weight-demi mb-auto">{new Intl.DateTimeFormat("fr-FR").format(userState.user.creationDate)}</p>
									) : (
										<p className="h6 font-weight-demi mb-auto">{R.isNil(userState.user.onBoardingCompletedDate) ? "" : new Intl.DateTimeFormat("fr-FR").format(new Date(currentDate.getFullYear(), userState.user.onBoardingCompletedDate.getMonth(), userState.user.onBoardingCompletedDate.getDate()))}</p>
									)
								) : userState.user.onBoardingCompletedDate ? (
									<p className="h6 font-weight-demi mb-auto">{R.isNil(userState.user.onBoardingCompletedDate) ? "" : new Intl.DateTimeFormat("fr-FR").format(userState.user.onBoardingCompletedDate)}</p>
								) : (
									<p className="h6 font-weight-demi mb-auto">--</p>
								)}
							</div>
							<div className="col-auto">
								<button type="button" className="btn btn-white-primary p-1 mr-md-0 rounded-max " data-toggle="modal" data-target="#DonnesProfile">
									<span className="btn-icon btn-stage-primary p-2 align-middle">
										<i className="eva fs-sm eva-person-outline" data-toggle="tooltip" data-placement="top" data-template='<div className="tooltip" role="tooltip"><div className="arrow"></div><div className="tooltip-inner px-3 py-2 rounded font-weight-regular lh-root"></div></div>' title="Données personnelles"></i>
									</span>
									<span className="mx-2 align-middle">Données personnelles</span>
								</button>
								<button type="button" className="btn btn-icon btn-white-secondary rounded-max p-xs mx-1" onClick={() => dispatch(resetPassword(userState.user.email, userState.user.phoneNumber))}>
									<i className="eva fs-sm eva-email-outline" data-toggle="tooltip" data-placement="top" data-template='<div class="tooltip tooltip-white-secondary" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>' title="Envoyer un e-mail de récupération"></i>
								</button>
								<button
									type="button"
									className="btn btn-icon btn-white-info rounded-max p-xs mx-1"
									data-toggle="modal"
									data-target="#paySummary"
									onClick={() => {
										handleGetPartnerAndEtablissement();
									}}>
									<i className="eva fs-sm eva-file-text-outline" data-toggle="tooltip" data-placement="top" data-template='<div class="tooltip tooltip-white-info" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>' title="Voir le détail du factures"></i>
								</button>

								{/* <button className="btn btn-icon btn-stage-primary rounded-max p-2 mx-1" data-toggle="modal" data-target="#AlertProfile"><i className="eva fs-sm eva-bell-outline" data-toggle="tooltip" data-placement="top" data-template='<div className="tooltip" role="tooltip"><div className="arrow"></div><div className="tooltip-inner px-3 py-2 rounded font-weight-regular lh-root"></div></div>' title="Envoyer une alerte"></i></button> */}
								{/* <button className="btn btn-icon btn-stage-primary rounded-max p-2 mx-1" data-toggle="modal" data-target="#DonnesProfile"><i className="eva fs-sm eva-person-outline" data-toggle="tooltip" data-placement="top" data-template='<div className="tooltip" role="tooltip"><div className="arrow"></div><div className="tooltip-inner px-3 py-2 rounded font-weight-regular lh-root"></div></div>' title="Données personnelles"></i></button>
								<button className="btn btn-icon btn-stage-primary rounded-max p-2 mx-1" data-toggle="modal" data-target="#HistoriqueProfile"><i className="eva fs-sm eva-calendar-outline" data-toggle="tooltip" data-placement="top" data-template='<div className="tooltip" role="tooltip"><div className="arrow"></div><div className="tooltip-inner px-3 py-2 rounded font-weight-regular lh-root"></div></div>' title="Voir l'histoire"></i></button>
								<button className="btn btn-icon btn-stage-primary rounded-max p-2 mx-1" data-toggle="modal" data-target="#EditProfile"><i className="eva fs-sm eva-edit-2-outline" data-toggle="tooltip" data-placement="top" data-template='<div className="tooltip" role="tooltip"><div className="arrow"></div><div className="tooltip-inner px-3 py-2 rounded font-weight-regular lh-root"></div></div>' title="Modifier dónnes"></i></button> */}
							</div>
						</div>
						<hr />
						<div className="row gx-2 gy-1">
							<div className="col-12 col-xl">
								<div className={"progress position-relative mb-auto w-100 text-center h-4 rounded-max align-items-center bg-dim"}>
									<div className={"progress-bar h-100 rounded-inherit"} style={{ width: `0%` }} role="progressbar"></div>
									<div className={"d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder h6 my-auto text-uppercase lh-solid"} role="progressbar">
										{statusOptions[userState.user.status]}
									</div>
								</div>
							</div>
							<div className="col">
								<div className="h6 font-weight-bolder mt-auto text-capitalize mb-1">Numéro de processus</div>
								<p className="h5 mb-auto">{userState.user.processNumber}</p>
							</div>
							{userDocuments.items.map((doc, index) => (
								<div className="col" key={doc.secondTitle + index}>
									<div className="h6 font-weight-bolder mt-auto text-capitalize mb-1">D. {doc.secondTitle}</div>
									<div className="progress progress-lg mb-auto bg-common">
										<div className="progress-bar bg-primary o-10 rounded-inherit" role="progressbar" style={{ width: `${doc.percent}%` }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
										<div className="progress-text my-auto text-uppercase o-60" role="progressbar">
											{doc.done}/{doc.num}
										</div>
									</div>
								</div>
							))}
							{/* <div className="col">
								<div className="h6 font-weight-bolder mt-auto text-capitalize mb-1">D. Communes</div>
								<div className="progress progress-lg mb-auto bg-common">
									<div className="progress-bar bg-primary o-10 rounded-inherit" role="progressbar" style={{ width: `93%` }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
									<div className="progress-text my-auto text-uppercase o-60" role="progressbar">9/12</div>
								</div>
							</div>
							<div className="col">
								<div className="h6 font-weight-bolder mt-auto text-capitalize mb-1">D. Personnalisées</div>
								<div className="progress progress-lg mb-auto bg-common">
									<div className="progress-bar bg-primary o-10 rounded-inherit" role="progressbar" style={{ width: `0%` }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
									<div className="progress-text my-auto text-uppercase o-60" role="progressbar">pas ajouté</div>
								</div>
							</div> */}
							<div className="col">
								<div className="h6 font-weight-bolder mt-auto text-capitalize mb-1">Référent Principal</div>
								<div className="h5 mb-auto">
									<i className="eva eva-person-done align-middle mr-1 text-primary"></i>
									<span className="align-middle">
										{userState.isLoading.includes(Loadings.FETCH_REPRESENTATIVES) ? (
											<div className="spinner-border spinner-border-sm text-primary ml-1" role="status">
												<span className="sr-only">Loading...</span>
											</div>
										) : mainRepresentative ? (
											`${mainRepresentative?.firstName} ${mainRepresentative?.lastName}`
										) : (
											""
										)}
									</span>
								</div>
							</div>
						</div>
					</header>
				</div>
				<div className="auto-view gd-view mb-auto">
					<div className="container-fluid">
						{(userState.isLoading.includes(Loadings.FETCH_SERVICES) || userState.isLoading.includes(LoadingsFacilita.FETCHING_USER_SERVICES_DATA)) && R.isEmpty(userState.serviceDatas) ? (
							<div className="d-flex flex-column justify-content-center align-items-center h-100">
								<div className="spinner-border spinner-border-sm text-primary ml-1" role="status">
									<span className="sr-only">Loading...</span>
								</div>
							</div>
						) : R.isEmpty(userState.services) ? (
							<section className="block fs-3 text-center m-auto py-4">
								<img className="img-fluid img-contain container-paper mx-auto  mt-auto mb-4" src={Emptylustration} alt="Assist@" />
								<div className="block text-center container-thin mx-auto mb-auto">
									<h1 className="font-weight-bolder ls-n2 lh-1">Il n'y a pas de services.</h1>
									<p className="o-80 mb-0">L'utilisateur veuillez ajouter un nouvel service.</p>
								</div>
							</section>
						) : (
							<form className="grid grid-sm-min grid-lg-tight grid-lg-4 grid-xl-demarche">
								{R.sortWith([R.ascend(R.prop("title"))])(Object.values(CommonServices).filter((u) => userState.services.some((i) => i.connectionType === u.connectionType))).map((srv, index) => {
									return <DossiersCard key={index} srv={srv} index={index} setServiceDataLetters={setServiceDataLetters} setSelectedServices={setSelectedServices} setSelectedUserService={setSelectedUserService} setServiceLetter={setServiceLetter} userState={userState} />;
								})}

								{R.sortWith([R.ascend(R.prop("title"))])(
									Object.values(PersonalServices)
										.concat(Object.values(AuxiliarOptions))
										.filter((u) => userState.services.some((i) => (isSocialNetwork(i.connectionType) ? ConnectionTypes.socialNetworks === u.connectionType : isInsurance(i.connectionType) ? ConnectionTypes.insurance === u.connectionType : i.connectionType === u.connectionType)))
								).map((srv, index) => {
									return <DossiersCard key={index} srv={srv} index={index} setServiceDataLetters={setServiceDataLetters} setSelectedServices={setSelectedServices} setSelectedUserService={setSelectedUserService} setServiceLetter={setServiceLetter} userState={userState} />;
								})}

								{R.sortWith([R.ascend(R.prop("title"))])(Object.values(OtherService).filter((u) => userState.services.some((i) => i.connectionType === u.connectionType))).map((srv, index) => {
									return <DossiersCard key={index} srv={srv} index={index} setServiceDataLetters={setServiceDataLetters} setSelectedServices={setSelectedServices} setSelectedUserService={setSelectedUserService} setServiceLetter={setServiceLetter} userState={userState} />;
								})}
							</form>
						)}

						{/* {Preview doc modal} */}
						{/* <PreviewDoc serviceDataLetters={serviceDataLetters} selectedUserService={selectedUserService} selectedUserLetter={selectedUserLetter} setSelectedUserService={setSelectedUserService} setSelectedUserLetter={setSelectedUserLetter} documentUrl={documentUrl} selectedServices={selectedServices} setServiceLetter={setServiceLetter} serviceLetter={serviceLetter} /> */}
						<PreviewDocLetter
							serviceDataLetters={serviceDataLetters}
							selectedUserService={selectedUserService}
							selectedUserLetter={selectedUserLetter}
							setSelectedUserService={setSelectedUserService}
							setSelectedUserLetter={setSelectedUserLetter}
							documentUrl={documentUrl}
							selectedServices={selectedServices}
							setServiceLetter={setServiceLetter}
							serviceLetter={serviceLetter}
						/>
						{/* <PreviewTest /> */}
					</div>
				</div>
				<DonnesProfile
					email={userState.user.email}
					phoneNumber={userState.user.phoneNumber}
					firstName={userState.user.firstName}
					lastName={userState.user.lastName}
					gender={userState.user.gender}
					birthDate={userState.user.birthDate}
					processNumber={userState.user.processNumber}
					civilStatus={userState.user.civilStatus}
					professionalSituation={userState.user.professionalSituation}
					address={userState.address}
					mainRepresentative={mainRepresentative}
					representatives={representatives}
					userDocuments={userDocuments}
					isDeceased={userState.user.isDeceased}
					recipientEmail={userState.user.recipientEmail}
				/>
				<CloseProfile user={userState.user} />
				<AlertProfile />
				<HistoriqueProfile />
				<EditProfile />
				<PrinterDoc />
				<PaySummary invoices={userState.invoices} partner={userState.partner} etablissement={userState.etablissement} />
				<PrintModal validatedletterSections={validatedletterSections} user={userState.user} isLoading={userState.isLoading} />
			</article>
		</React.Fragment>
	);
};
